import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-activity-config-category",
  "use": "icon-activity-config-category-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-activity-config-category\"><defs><style type=\"text/css\"></style></defs><path d=\"M468.8 484.6H276.6c-114.4 0-208.1-93.6-208.1-208.1 0-114.4 93.6-208.1 208.1-208.1 114.4 0 208.1 93.6 208.1 208.1v192.2c-0.1 8.8-7.2 15.9-15.9 15.9zM747.4 484.6H555.2c-8.7 0-15.8-7.1-15.8-15.8V276.6c0-114.4 93.6-208.1 208.1-208.1 114.4 0 208.1 93.6 208.1 208.1-0.1 114.4-93.7 208-208.2 208zM276.6 955.5c-114.4 0-208.1-93.6-208.1-208.1 0-114.4 93.6-208.1 208.1-208.1h192.2c8.7 0 15.8 7.1 15.8 15.8v192.2c0 114.6-93.6 208.2-208 208.2zM747.4 955.5c-114.4 0-208.1-93.6-208.1-208.1V555.2c0-8.7 7.1-15.8 15.8-15.8h192.2c114.4 0 208.1 93.6 208.1 208.1 0.1 114.4-93.5 208-208 208z\" p-id=\"1913\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/activity-config-category.svg
// module id = 1LPK
// module chunks = 115